import { AdminRoutes } from "config/routes";
import { AuthGuidePage } from "./AuthGuidePage";
import { findAccountGuideMarkdown } from "./content/findAccountGuide";

export const FindAccountGuide = () => (
  <AuthGuidePage
    markdown={findAccountGuideMarkdown}
    actionPath={AdminRoutes.AccountRecovery}
    actionLabel="Go to Find My Account"
  />
);
